var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("q-form", { ref: "editForm" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            {
              staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
            },
            [
              _c(
                "c-card",
                {
                  staticClass: "cardClassDetailForm",
                  attrs: { title: "페기물 처리결과" },
                },
                [
                  _c(
                    "template",
                    { slot: "card-button" },
                    [
                      _c(
                        "q-btn-group",
                        { attrs: { outline: "" } },
                        [
                          _vm.editable && _vm.popupParam.envWasteAllbaroId
                            ? _c("c-btn", {
                                attrs: { label: "LBLREMOVE", icon: "remove" },
                                on: { btnClicked: _vm.deleteData },
                              })
                            : _vm._e(),
                          _vm.editable
                            ? _c("c-btn", {
                                attrs: {
                                  url: _vm.saveUrl,
                                  isSubmit: _vm.isSave,
                                  param: _vm.data,
                                  mappingType: _vm.mappingType,
                                  label: "LBLSAVE",
                                  icon: "save",
                                },
                                on: {
                                  beforeAction: _vm.saveInfo,
                                  btnCallback: _vm.saveCallback,
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("template", { slot: "card-detail" }, [
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: _vm.editable,
                            label: "인계번호",
                            name: "envWasteAllbaroNo",
                          },
                          model: {
                            value: _vm.data.envWasteAllbaroNo,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "envWasteAllbaroNo", $$v)
                            },
                            expression: "data.envWasteAllbaroNo",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-datepicker", {
                          attrs: {
                            required: true,
                            label: "인계일자",
                            name: "allbaroDt",
                          },
                          model: {
                            value: _vm.data.allbaroDt,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "allbaroDt", $$v)
                            },
                            expression: "data.allbaroDt",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-text", {
                          attrs: {
                            required: true,
                            editable: _vm.editable,
                            label: "폐기물종류(성상)",
                            name: "wasteType",
                          },
                          model: {
                            value: _vm.data.wasteType,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "wasteType", $$v)
                            },
                            expression: "data.wasteType",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-1" },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: _vm.editable,
                            label: "구분",
                            name: "wasteTypeCd",
                          },
                          model: {
                            value: _vm.data.wasteTypeCd,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "wasteTypeCd", $$v)
                            },
                            expression: "data.wasteTypeCd",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-2" },
                      [
                        _c("c-select", {
                          attrs: {
                            comboItems: _vm.endFlagItems,
                            type: "edit",
                            itemText: "codeName",
                            itemValue: "code",
                            name: "endFlag",
                            label: "확정여부",
                          },
                          model: {
                            value: _vm.data.endFlag,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "endFlag", $$v)
                            },
                            expression: "data.endFlag",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-4" },
                      [
                        _c("c-text", {
                          attrs: {
                            type: "number",
                            required: true,
                            editable: _vm.editable,
                            label: "위탁량",
                            name: "wasteVolume",
                          },
                          model: {
                            value: _vm.data.wasteVolume,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "wasteVolume", $$v)
                            },
                            expression: "data.wasteVolume",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-2" },
                      [
                        _c("c-select", {
                          attrs: {
                            required: true,
                            comboItems: _vm.wasteVolumeUnitItems,
                            type: "edit",
                            itemText: "codeName",
                            itemValue: "code",
                            name: "wasteVolumeUnit",
                            label: "LBLUNIT",
                          },
                          model: {
                            value: _vm.data.wasteVolumeUnit,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "wasteVolumeUnit", $$v)
                            },
                            expression: "data.wasteVolumeUnit",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-text", {
                          attrs: {
                            type: "number",
                            editable: _vm.editable,
                            label: "처리자인수량",
                            name: "wasteVolumeInsu",
                          },
                          model: {
                            value: _vm.data.wasteVolumeInsu,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "wasteVolumeInsu", $$v)
                            },
                            expression: "data.wasteVolumeInsu",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: _vm.editable,
                            label: "운반자명",
                            name: "transportName",
                          },
                          model: {
                            value: _vm.data.transportName,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "transportName", $$v)
                            },
                            expression: "data.transportName",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-text", {
                          attrs: {
                            required: true,
                            editable: _vm.editable,
                            label: "차량번호",
                            name: "carNo",
                          },
                          model: {
                            value: _vm.data.carNo,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "carNo", $$v)
                            },
                            expression: "data.carNo",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: _vm.editable,
                            label: "처리자명",
                            name: "processName",
                          },
                          model: {
                            value: _vm.data.processName,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "processName", $$v)
                            },
                            expression: "data.processName",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: _vm.editable,
                            label: "처리방법",
                            name: "processMethod",
                          },
                          model: {
                            value: _vm.data.processMethod,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "processMethod", $$v)
                            },
                            expression: "data.processMethod",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: _vm.editable,
                            label: "처리장소",
                            name: "processLocation",
                          },
                          model: {
                            value: _vm.data.processLocation,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "processLocation", $$v)
                            },
                            expression: "data.processLocation",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-text", {
                          attrs: {
                            required: true,
                            editable: _vm.editable,
                            label: "인계자명",
                            name: "transferName",
                          },
                          model: {
                            value: _vm.data.transferName,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "transferName", $$v)
                            },
                            expression: "data.transferName",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-select", {
                          attrs: {
                            comboItems: _vm.emitterFlagItems,
                            type: "edit",
                            itemText: "codeName",
                            itemValue: "code",
                            name: "emitterFlag",
                            label: "공동배출자여부",
                          },
                          model: {
                            value: _vm.data.emitterFlag,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "emitterFlag", $$v)
                            },
                            expression: "data.emitterFlag",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: _vm.editable,
                            label: "입력구분",
                            name: "inputFlag",
                          },
                          model: {
                            value: _vm.data.inputFlag,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "inputFlag", $$v)
                            },
                            expression: "data.inputFlag",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: _vm.editable,
                            label: "관할관청",
                            name: "officeName",
                          },
                          model: {
                            value: _vm.data.officeName,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "officeName", $$v)
                            },
                            expression: "data.officeName",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: _vm.editable,
                            label: "LBLPROGRESS",
                            name: "status",
                          },
                          model: {
                            value: _vm.data.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "status", $$v)
                            },
                            expression: "data.status",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: _vm.editable,
                            label: "처리결과",
                            name: "processResult",
                          },
                          model: {
                            value: _vm.data.processResult,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "processResult", $$v)
                            },
                            expression: "data.processResult",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-select", {
                          attrs: {
                            comboItems: _vm.ipItems,
                            type: "edit",
                            itemText: "codeName",
                            itemValue: "code",
                            name: "transportIp",
                            label: "운반IP동일",
                          },
                          model: {
                            value: _vm.data.transportIp,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "transportIp", $$v)
                            },
                            expression: "data.transportIp",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-select", {
                          attrs: {
                            comboItems: _vm.ipItems,
                            type: "edit",
                            itemText: "codeName",
                            itemValue: "code",
                            name: "processIp",
                            label: "처리IP동일",
                          },
                          model: {
                            value: _vm.data.processIp,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "processIp", $$v)
                            },
                            expression: "data.processIp",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: _vm.editable,
                            label: "예외사유",
                            name: "remark",
                          },
                          model: {
                            value: _vm.data.remark,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "remark", $$v)
                            },
                            expression: "data.remark",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-field", {
                          attrs: {
                            required: true,
                            editable:
                              _vm.editable && !_vm.popupParam.envWasteAllbaroId,
                            data: _vm.data,
                            deptValue: "deptCd",
                            type: "dept_user",
                            label: "작성부서 & 작성자",
                            name: "userId",
                          },
                          model: {
                            value: _vm.data.userId,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "userId", $$v)
                            },
                            expression: "data.userId",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-plant", {
                          attrs: {
                            required: true,
                            type: "edit",
                            name: "plantCd",
                          },
                          model: {
                            value: _vm.data.plantCd,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "plantCd", $$v)
                            },
                            expression: "data.plantCd",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }